import { Routes } from '@angular/router';

import { PUBLIC_ROUTES, PRIVATE_ROUTES, ADMIN_ROUTES } from './routes';


import { PublicLayout, PrivateLayout, AdminLayout } from './layouts';

import { SecurityGuard } from './services';
import { NoContentPage } from './pages';

export const ROUTES: Routes = [
    { path: '', redirectTo: '/tactic', pathMatch: 'full', },
    { path: '', component: PublicLayout, children: PUBLIC_ROUTES },
    { path: '', component: PrivateLayout, canActivate: [SecurityGuard], children: PRIVATE_ROUTES },
    { path: '', component: AdminLayout, canActivate: [SecurityGuard], children: ADMIN_ROUTES },
    { path: '**',    component: NoContentPage },
];
